<script lang="ts" setup>
import Operation from './Operation.vue';
import Calendar from './Calendar.vue';

const props = defineProps({
  isOperation: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="relative pt-80">
    <h2 class="text-45 text-#0a0b5c font-bold leading-74">更多活动尽在这里 期待您的参与</h2>
    <p class="text-16 text-#263238 font-normal leading-32">Here are more exciting events—looking forward to your participation!</p>
    <Operation v-if="props.isOperation" class="relative z-1" />
    <Calendar class="relative z-1" />
    <img src="@/home/assets/home/4/bg1.png" class="pointer-events-none absolute right--100 top--230 h-372 w-425 object-cover" v-if="props.isOperation">
    <img src="@/home/assets/home/4/bg2.png" class="absolute left--92 top-224 z-0 h-176 w-142 object-cover">
  </div>
</template>

<style lang="scss" scoped>
</style>
